import { ReactElement } from 'react';

import { ServiceProvidingLocationUpdateMedicalFieldCommand } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';
import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { dischargeSummaryTranslationKeys } from '../../../translations';

import { MedicalFieldFormBean, MedicalFieldFormController } from './MedicalFieldForm.types';

type MedicalFieldSaveAndContinueModalConfirmButtonProps = Pick<MedicalFieldFormController, 'handleSubmit'> & {
   onSuccess: VoidFunction;
   serviceProvidingLocationId: number;
};

export const MedicalFieldSaveAndContinueModalConfirmButton = (
   props: MedicalFieldSaveAndContinueModalConfirmButtonProps
): ReactElement => {
   const { executeAsync: saveMedicalField } = useCqrsCommand<void, MedicalFieldFormBean>(
      (parameters) => {
         const command = new ServiceProvidingLocationUpdateMedicalFieldCommand();
         command.medicalFieldId = parameters.medicalField!.id;
         command.id = props.serviceProvidingLocationId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(dischargeSummaryTranslationKeys.medicalFieldSaved);
            props.onSuccess();
         },
      }
   );
   return (
      <ModalConfirmButton
         label={dischargeSummaryTranslationKeys.saveAndContinue}
         onClick={props.handleSubmit(saveMedicalField)}
      />
   );
};
